export default __webpack_public_path__ + "static/pattern-orange-small-89dc55aac0ddf223593002923db55efc.svg";